import AxiosInstance from "./api";

export const VerificationReportService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/verification-report", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/verification-report/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/verification-report", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/verification-report/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/verification-report/${id}`);
  },
};
